import { app } from '../../../../app';

app.component('editHardToken', {
    bindings: {
        companyId: '<',
        token: '<',
    },
    templateUrl: require('./hard-token-edit.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/hard-token-management/hard-token-edit/hard-token-edit.component.js